import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { UsersIcon, WrenchIcon, TargetIcon, ZapIcon, QuoteIcon } from 'lucide-react';
const TrustCard = ({
  icon: Icon,
  title,
  description
}: {
  icon: any;
  title: string;
  description: string;
}) => {
  return <div className="glass-card p-5 sm:p-8" data-id="element-362">
      <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gold-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-gold-500/20" data-id="element-363">
        <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-gold-600" data-id="element-364" />
      </div>
      <h3 className="text-base sm:text-xl font-bold text-slate-900 mb-2 sm:mb-3" data-id="element-365">
        {title}
      </h3>
      <p className="text-xs sm:text-base text-slate-600 leading-relaxed" data-id="element-366">
        {description}
      </p>
    </div>;
};
export function WhyDigilite() {
  return <SlideLayout data-id="element-367">
      <div className="mb-6 sm:mb-12 text-center" data-id="element-368">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full mx-auto" data-id="element-369" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-370">
          Why Digilite
        </h2>
        <p className="text-sm sm:text-xl text-slate-500 max-w-2xl mx-auto" data-id="element-371">
          Your growth partner, not just another agency.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mb-6 sm:mb-12" data-id="element-372">
        <TrustCard icon={UsersIcon} title="Customer-Centric Approach" description="Every strategy is built around your business goals, target audience, and competitive landscape — not cookie-cutter templates." data-id="element-373" />
        <TrustCard icon={WrenchIcon} title="Custom-Tailored Solutions" description="We combine technology and marketing expertise to create solutions specifically designed for your mortgage business." data-id="element-374" />
        <TrustCard icon={TargetIcon} title="Results-Driven Execution" description="We measure success by your results — more rankings, more traffic, more qualified leads, and more closed deals." data-id="element-375" />
        <TrustCard icon={ZapIcon} title="Maximum Value, Minimum Waste" description="We focus on high-impact actions that deliver the greatest ROI in the shortest timeframe — no fluff, no filler." data-id="element-376" />
      </div>

      <div className="relative p-5 sm:p-8 rounded-xl sm:rounded-2xl bg-gradient-to-r from-slate-50 to-white border border-slate-200 text-center shadow-sm" data-id="element-377">
        <QuoteIcon className="absolute top-3 left-3 sm:top-4 sm:left-4 w-6 h-6 sm:w-8 sm:h-8 text-slate-900/5" data-id="element-378" />
        <QuoteIcon className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 w-6 h-6 sm:w-8 sm:h-8 text-slate-900/5 rotate-180" data-id="element-379" />
        <p className="text-sm sm:text-xl md:text-2xl text-slate-900 font-light italic leading-relaxed max-w-4xl mx-auto" data-id="element-380">
          "We don't just deliver reports — we deliver results. Our team becomes
          an extension of yours, focused on growing your mortgage business
          through strategic digital marketing."
        </p>
      </div>
    </SlideLayout>;
}